var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a47443f9-5932-4497-9a4a-46c237074950",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b7099bc5-aacd-465d-b1a1-5143cfaa47c8",
    "data-name": "Path 122149",
    d: "M10.79.24a.91.91,0,0,1,0,1.16L5.91,6.81a.53.53,0,0,1-.76.06.12.12,0,0,1-.06-.06L.22,1.4A.88.88,0,0,1,.22.24a.68.68,0,0,1,1-.07l.07.07L5.5,5,9.75.24a.67.67,0,0,1,1-.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.1ee93257e38ee98c367a656e14a77ec6.svg";
export { ForwardRef as ReactComponent };